module.exports = __webpack_public_path__ + "img/hero-lg.e694ded6.png";